import { render } from "./FilterAccordion.vue?vue&type=template&id=58f0c8dc"
import script from "./FilterAccordion.vue?vue&type=script&lang=js"
export * from "./FilterAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__